module.exports = __webpack_public_path__ + "img/bidinfo.ed146ba2.svg";